import { FC } from 'react';
import ModalDialog from '../components/modal/ModalDialog';
import { useTranslation } from 'react-i18next';

interface Props {
    onClose: () => void;
    onConfirm: () => void;
    infoNotification: {
        showCancel: boolean;
        message: string;
        dataDisplay: string;
        title: string;
        submitLabel: string;
    };
}

const NotificationWithInfo: FC<Props> = props => {
    const { t } = useTranslation();
    const { infoNotification, onClose, onConfirm } = props;
    const info = infoNotification;

    if (!info) {
        return null;
    }

    return (
        <ModalDialog show={!!info} title={info.title}>
            <div className="data" dangerouslySetInnerHTML={{ __html: info.dataDisplay ?? '' }} />
            <p>{info.message}</p>
            <div className="dlb-actions">
                {info.showCancel ? (
                    <a className="lk" onClick={onClose}>
                        {t('cancel')}
                    </a>
                ) : null}
                <a className="lk lk-primary" onClick={onConfirm}>
                    {info.submitLabel || t('ok')}
                </a>
            </div>
        </ModalDialog>
    );
};

export default NotificationWithInfo;
